import { Skeleton } from "./skeleton";

export const PageSkeleton = () => {
  // Simpler skeleton for mobile to reduce flicker
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 1024;
  
  if (isMobile) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface pt-16">
        <div className="space-y-3 text-center">
          <div className="flex justify-center gap-2">
            <div className="w-3 h-3 bg-primary rounded-full animate-pulse" style={{ animationDelay: '0ms' }} />
            <div className="w-3 h-3 bg-primary rounded-full animate-pulse" style={{ animationDelay: '150ms' }} />
            <div className="w-3 h-3 bg-primary rounded-full animate-pulse" style={{ animationDelay: '300ms' }} />
          </div>
          <p className="text-sm text-muted-foreground">Laddar...</p>
        </div>
      </div>
    );
  }
  
  // Full skeleton for desktop
  return (
    <div className="min-h-screen bg-surface">
      {/* Hero Skeleton */}
      <div className="container py-16 md:py-24">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <Skeleton className="h-16 w-3/4" />
            <Skeleton className="h-8 w-full" />
            <Skeleton className="h-8 w-5/6" />
            <div className="flex gap-4 mt-8">
              <Skeleton className="h-6 w-32" />
              <Skeleton className="h-6 w-32" />
              <Skeleton className="h-6 w-32" />
            </div>
          </div>
          <Skeleton className="h-96 w-full rounded-2xl" />
        </div>
      </div>

      {/* Goals Section Skeleton */}
      <div className="container py-16">
        <Skeleton className="h-12 w-64 mx-auto mb-12" />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {[1, 2, 3, 4].map((i) => (
            <Skeleton key={i} className="h-48 w-full rounded-xl" />
          ))}
        </div>
      </div>

      {/* Product Sections Skeleton */}
      {[1, 2].map((section) => (
        <div key={section} className="container py-16">
          <div className="flex justify-between items-center mb-8">
            <Skeleton className="h-10 w-64" />
            <Skeleton className="h-10 w-48" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3].map((i) => (
              <Skeleton key={i} className="h-72 w-full rounded-xl" />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
